import NullTableRegion from "../table/NullTableRegion"
import TableRegion from "../table/TableRegion"
import DateRange from "../DateRange"
import RunnerSelectionType from "./RunnerSelectionType"

export default class RunnerController{
    constructor( lastLockedDate, selectionController, hoverController, allLockedTillDateBeyondDateRange )
    {
        this.selectionController = selectionController;
        this.hoverController = hoverController;
        this.lastLockedDate = lastLockedDate;
        this.allLockedTillDateBeyondDateRange = allLockedTillDateBeyondDateRange;
        this.newLastLockedCell = null;
        this.selectedRegion = NullTableRegion;
        this.listeners = [];

        var runnerController = this;
        this.selectingAffectedCells = false;
        this.selectionController.addSelectionChangeListener(
            function( selectionChangeEvent )
            {
                if( !runnerController.selectingAffectedCells )
                    runnerController.removeSelection();
            } );
    }

    addPositionChangeListener ( listener )
    {
        this.listeners.push( listener );
    };

    firePositionChangeEvent ()
    {
        for( var i = 0; i < this.listeners.length; i++ )
            this.listeners[i].call( this.listeners[i], this.lastLockedDate );
    };

    getLastLockedDate ()
    {
        return this.lastLockedDate;
    };

    hover ( cell )
    {
        if( !this.hasSelection() )
            this.moveLockTo( cell, false );
    };

    unhover ( cell )
    {
        if( !this.hasSelection() )
        {
            this.newLastLockedCell = null;
            this.hoverController.unhover();
        }
    };

    moveLockTo ( cell, setSelection )
    {
        if ( this.lastLockedDate == null || this.lastLockedDate < cell.getValue().date )
        {
            this.moveLockForward( cell, setSelection );
        }
        else if ( this.lastLockedDate > cell.getValue().date )
        {
            this.moveLockBack( cell, setSelection );
        }
    };

    moveLockBack(cell, setSelection) {
        this.newLastLockedCell = cell
        this.hoverController.hover(cell, this.getLastLockedCell(cell.getRow()))

        if (setSelection) {
            this.selectedRegion = this.hoverController.hoverRegion
            this.hoverController.unhover()
            const datesRowCells = this.selectionController.lockTable.datesRow.cells
            if (this.selectedRegion.colMax !== this.selectedRegion.colMin) {
                this.selectAffectedRegion(cell.getRow().getTable(), this.selectedRegion.colMin + 1, this.selectedRegion.colMax)
            } else if (this.selectedRegion.colMin === datesRowCells[datesRowCells.length - 1].colIdx
                       && datesRowCells[datesRowCells.length - 1].value.date < this.lastLockedDate) {
                this.selectAffectedRegion(cell.getRow().getTable(), this.selectedRegion.colMin, this.selectedRegion.colMax)
            } else {
                this.selectAffectedCells(null, null)
            }
        }
    }

    moveLockForward ( cell, setSelection )
    {
        this.newLastLockedCell = cell;
        this.hoverController.hover( this.getLastLockedCell( cell.getRow() ), cell );

        if( setSelection )
        {
            this.selectedRegion = this.hoverController.hoverRegion;
            this.hoverController.unhover();
            var xStart = this.selectedRegion.colMin;
            if( cell.getRow().getCell( xStart ).getValue().runnerOver )
                xStart = xStart + 1;

            this.selectAffectedRegion( cell.getRow().getTable(), xStart, this.selectedRegion.colMax )
        }
    };

    selectAffectedRegion ( lockTable, xStart, xEnd )
    {
        this.selectAffectedCells( lockTable.getDatesRow().getCell( xStart ),
            lockTable.getLastSelectableRow().getCell( xEnd ) );
    };

    selectAffectedCells ( startCell, endCell )
    {
        this.selectingAffectedCells = true;
        try
        {
            this.selectionController.setSelectionAnchor( startCell );
            this.selectionController.setSelectionType( new RunnerSelectionType() );
            if( endCell )
                this.selectionController.changeSelectionTo( endCell );
        }
        finally
        {
            this.selectingAffectedCells = false;
        }
    };

    getLastLockedCell ( runnerRow )
    {
        if( this.lastLockedDate == null || runnerRow.getCell(1).getValue().date > this.lastLockedDate )
        {
            return runnerRow.getCell(1);
        }

        var lastCell = runnerRow.getCell( runnerRow.getCells().length - 1 );
        if( lastCell.getValue().date < this.lastLockedDate )
        {
            return lastCell;
        }

        for ( var i = 1; i <= runnerRow.getCells().length; i++ )
        {
            var curCell = runnerRow.getCell(i);
            if( curCell.getValue().date.getTime() == this.lastLockedDate.getTime() )
            {
                return curCell;
            }
        }
    };

    removeSelection ()
    {
        if( !this.hasSelection() )
            return;

        var updatedRegion = this.selectedRegion;
        var runnerRow = this.newLastLockedCell.getRow();

        this.selectedRegion = NullTableRegion;
        this.newLastLockedCell = null;

        for ( var i = 1; i < runnerRow.getCells().length; i++ )
        {
            if ( updatedRegion.contains( runnerRow.getRowIdx(), i ) )
            {
                runnerRow.getCell(i).updateUI();
            }
        }
    };

    setNewLastLockedCell ( cell )
    {
        this.removeSelection();

        if( cell != null )
        {
            this.moveLockTo( cell, true );
        }
    };

    isSelected ( cell )
    {
        return this.hasSelection() && this.selectedRegion.contains( cell.getRow().getRowIdx(), cell.getColIdx() );
    };

    getNextDate ( date )
    {
        return Date.create(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    };

    getPreviousDate ( date )
    {
        return Date.create(date.getFullYear(), date.getMonth(), date.getDate() - 1);
    };

    getSelectedDateRange ()
    {
        if( this.newLastLockedCell != null )
        {
            if( this.lastLockedDate == null )
            {
                return new DateRange( null, this.newLastLockedCell.getValue().date );
            }
            else if( this.newLastLockedCell.getValue().date > this.lastLockedDate )
            {
                return new DateRange( this.getNextDate( this.lastLockedDate ), this.newLastLockedCell.getValue().date );
            }
            else
                return new DateRange( this.getNextDate( this.newLastLockedCell.getValue().date ), this.lastLockedDate );
        }
        return null;
    };

    isNewLastLocked ( cell )
    {
        return this.newLastLockedCell == cell;
    };

    getNewLastLockDate ()
    {
        return this.newLastLockedCell != null ? this.newLastLockedCell.getValue().date : null;
    };

    hasSelection ()
    {
        return this.selectedRegion != NullTableRegion;
    };

    /*
     * Checks locks for specified region and move runner forward if needed.
     */
    regionLocked ( lockTable, lockedRegion )
    {
        var runnerRow = lockTable.rows[0];
        var previousDate = this.getPreviousDate( runnerRow.getCell(lockedRegion.colMin).getValue().date );

        if( this.lastLockedDate == null || previousDate > this.lastLockedDate )
        {
            return;
        }

        var lastLockedCell = 0;
        var userRows = lockTable.getUserRows();
        for( var colIdx = lockedRegion.colMin; colIdx < runnerRow.getCells().length; colIdx++ )
        {
            var runnerCell = runnerRow.getCell( colIdx );
            if( !runnerCell.getValue().runnerOver )
            {
                if( runnerCell.getValue().hasUnlockedInvisibleUser )
                {
                    break;
                }

                var allLockedDate = true;
                for( var rowIdx = 0; rowIdx < userRows.length; rowIdx++ )
                {
                    var userCell = userRows[ rowIdx ].getCell( colIdx );
                    if( !userCell.getValue().locked )
                    {
                        allLockedDate = false;
                        break;
                    }
                }

                if( allLockedDate )
                {
                    runnerCell.getValue().runnerOver = true;
                    lastLockedCell = colIdx;
                }
                else
                {
                    break;
                }
            }
        }

        if( lastLockedCell > 0 )
        {
            if( this.allLockedTillDateBeyondDateRange != null && lastLockedCell == runnerRow.getCells().length - 1 )
            {
                this.lastLockedDate = this.allLockedTillDateBeyondDateRange;
            }
            else
            {
                this.lastLockedDate = runnerRow.getCell( lastLockedCell ).getValue().date;
            }
            this.firePositionChangeEvent();

            var startColumn = lockedRegion.colMin > 1 ? lockedRegion.colMin - 1 : lockedRegion.colMin;
            lockTable.updateCellRegionUI( new TableRegion( 0, startColumn, 0, lastLockedCell ) );
        }
    };

    /*
     * Checks locks for specified region and move runner back if needed.
     */
    regionUnlocked ( lockTable, unlockedRegion )
    {
        var runnerRow = lockTable.rows[0];

        if( !runnerRow.getCell( unlockedRegion.colMin ).getValue().runnerOver )
        {
            return;
        }

        var endColumn = 0;
        for( var colIdx = unlockedRegion.colMin; colIdx < runnerRow.getCells().length; colIdx++ )
        {
            var runnerCell = runnerRow.getCell( colIdx );
            if( runnerCell.getValue().runnerOver )
            {
                runnerCell.getValue().runnerOver = false;
                endColumn = colIdx;
            }
            else
            {
                break;
            }
        }

        this.lastLockedDate = this.getPreviousDate( runnerRow.getCell( unlockedRegion.colMin ).getValue().date );
        this.firePositionChangeEvent();

        var startColumn = unlockedRegion.colMin > 1 ? unlockedRegion.colMin - 1 : unlockedRegion.colMin;
        lockTable.updateCellRegionUI( new TableRegion( 0, startColumn, 0, endColumn ) );
    };

}


// WEBPACK FOOTER //
// ./web/js/locktable/RunnerController.js